/* Petits ajustements d'interface repris de kimurakami.com.
   1. Menu principal : ouverture au survol (le theme de base ouvre au clic).
   2. Pied de page sur mobile : chaque colonne devient un volet repliable. */
(() => {
  /* ---------- 1. menu au survol ---------- */
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    const entetes = () => document.querySelectorAll('.header__inline-menu details');
    let fermeture;
    const brancher = () => entetes().forEach((d) => {
      if (d.dataset.deSurvol) return;
      d.dataset.deSurvol = '1';
      const parent = d.parentElement;
      parent.addEventListener('mouseenter', () => {
        clearTimeout(fermeture);
        entetes().forEach((autre) => { if (autre !== d) autre.removeAttribute('open'); });
        d.setAttribute('open', '');
      });
      parent.addEventListener('mouseleave', () => {
        fermeture = setTimeout(() => d.removeAttribute('open'), 120);
      });
    });
    brancher();
    document.addEventListener('shopify:section:load', brancher);

    /* Sur grand ecran, un clic sur un rayon mene a sa collection : le panneau, lui,
       s'ouvre deja au survol. Sur ecran tactile on garde le comportement du theme de base,
       sinon le sous-menu deviendrait inaccessible. */
    document.addEventListener('click', (e) => {
      const resume = e.target.closest('.header__inline-menu summary[data-de-url]');
      if (!resume) return;
      const url = resume.dataset.deUrl;
      if (!url) return;
      e.preventDefault();
      window.location.href = url;
    });
  }

  /* ---------- 2. pied de page repliable sur mobile ---------- */
  const petit = window.matchMedia('(max-width: 749px)');

  const replier = (bloc) => {
    if (bloc.dataset.deVolet) return;
    const titre = bloc.querySelector('.footer-block__heading');
    const corps = bloc.querySelector('.footer-block__details-content');
    if (!titre || !corps) return;
    bloc.dataset.deVolet = '1';
    const details = document.createElement('details');
    details.className = 'de-volet';
    const resume = document.createElement('summary');
    resume.className = 'de-volet__titre';
    resume.append(titre.cloneNode(true));
    resume.insertAdjacentHTML('beforeend',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>');
    titre.remove();
    details.append(resume);
    const contenu = document.createElement('div');
    contenu.className = 'de-volet__corps';
    while (bloc.firstChild) contenu.append(bloc.firstChild);
    details.append(contenu);
    bloc.append(details);
  };

  const deplier = (bloc) => {
    const details = bloc.querySelector(':scope > details.de-volet');
    if (!details) return;
    const titre = details.querySelector('.footer-block__heading');
    const corps = details.querySelector('.de-volet__corps');
    bloc.textContent = '';
    if (titre) bloc.append(titre);
    while (corps && corps.firstChild) bloc.append(corps.firstChild);
    delete bloc.dataset.deVolet;
  };

  const ajuster = () => {
    // Le PREMIER bloc est la marque : il reste affiche tel quel, au-dessus du cadre,
    // comme sur kimurakami.com. Seuls les suivants deviennent des volets.
    const blocs = [...document.querySelectorAll('.footer__blocks-wrapper > .grid__item')].slice(1);
    blocs.forEach((b) => (petit.matches ? replier(b) : deplier(b)));
  };

  ajuster();
  petit.addEventListener('change', ajuster);
  document.addEventListener('shopify:section:load', ajuster);
})();

/* ---- Collections meres : les pastilles sont des ONGLETS, comme sur KK. Un clic remplace la grille
   par les 50 premiers produits de la sous-collection (la section grille de la page, rendue pour
   cette sous-collection) et « Alle anzeigen » pointe vers elle. Les grilles deja vues restent en cache. */
(() => {
  const cache = {};
  const grilleId = () => document.querySelector('[id^="shopify-section-"][id$="__product-grid"]')?.id.replace('shopify-section-', '');
  // les cartes injectees ne sont pas suivies par l'animation d'apparition du theme de base : on la retire
  const nettoyer = (li) => { li.classList.remove('scroll-trigger', 'animate--slide-in'); li.removeAttribute('data-cascade'); li.style.removeProperty('--animation-order'); return li.outerHTML; };
  const charger = (url) => (cache[url] ??= fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=${grilleId()}`)
    .then((r) => r.text())
    .then((html) => {
      const ul = new DOMParser().parseFromString(html, 'text/html').querySelector('#product-grid');
      return ul ? [...ul.children].filter((x) => x.tagName === 'LI').slice(0, 50).map(nettoyer).join('') : '';
    }));
  document.addEventListener('click', async (e) => {
    const onglet = e.target.closest('.de-pastilles [role="tab"]');
    if (!onglet || onglet.classList.contains('de-p--actif')) return;
    const bloc = document.querySelector('[data-de-onglets]');
    if (!bloc || !grilleId()) return;
    onglet.parentElement.querySelectorAll('[role="tab"]').forEach((x) => {
      const actif = x === onglet;
      x.classList.toggle('de-p--actif', actif);
      x.setAttribute('aria-selected', actif ? 'true' : 'false');
    });
    const panneau = bloc.querySelector('[data-de-panneau]');
    bloc.querySelector('[data-de-tout]').href = onglet.dataset.url;
    panneau.classList.add('de-charge');
    try { panneau.innerHTML = await charger(onglet.dataset.url); } finally { panneau.classList.remove('de-charge'); }
  });

  /* ---- Sous-collections : « Mehr anzeigen » ajoute la page suivante a la grille (le « Show more » de KK) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('.de-mehr-btn');
    if (!b || b.disabled) return;
    b.disabled = true;
    try {
      const url = new URL(b.dataset.next, location.origin);
      url.searchParams.set('section_id', b.dataset.section);
      const d = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
      const ul = document.querySelector('#product-grid');
      d.querySelectorAll('#product-grid > li').forEach((li) => { nettoyer(li); ul.appendChild(document.importNode(li, true)); });
      const suivant = d.querySelector('.de-mehr-btn');
      if (suivant) { b.dataset.next = suivant.dataset.next; b.disabled = false; } else b.closest('.de-mehr')?.remove();
    } catch { b.disabled = false; }
  });
})();

/* ---- Photos au survol des cartes produit, comme le « secondary-media » de Concept (KK) :
   3 photos -> moitie gauche = 2e, moitie droite = 3e ; 4 photos -> tiers ; sortie = 1re photo.
   Les images sont clonees depuis le <template> quand la carte approche de l'ecran. ---- */
(() => {
  if (!window.matchMedia('(hover: hover)').matches) return;
  const preparer = (survol) => {
    if (survol.dataset.pret) return;
    survol.dataset.pret = '1';
    const modele = survol.previousElementSibling;
    if (!modele || modele.tagName !== 'TEMPLATE') return;
    survol.prepend(modele.content.cloneNode(true));
    const imgs = [...survol.querySelectorAll('img')];
    const points = [...survol.querySelectorAll('.de-survol-points i')];
    const n = imgs.length;
    const zone = survol.closest('.card__inner') || survol.parentElement;
    const choisir = (i) => {
      imgs.forEach((im, k) => im.classList.toggle('actif', k === i));
      points.forEach((p, k) => p.classList.toggle('actif', k === i));
      survol.classList.toggle('en-cours', i > 0);
    };
    zone.addEventListener('mousemove', (e) => {
      const r = zone.getBoundingClientRect();
      const x = e.clientX - r.left;
      choisir(n >= 4 ? (x < r.width / 3 ? 1 : x < (2 * r.width) / 3 ? 2 : 3) : (x < r.width / 2 ? 1 : 2));
    });
    zone.addEventListener('mouseleave', () => choisir(0));
  };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entrees) => entrees.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); preparer(e.target); } }), { rootMargin: '200px 0px' })
    : null;
  // prepare a l'approche de l'ecran, et au plus tard quand la souris entre sur la carte
  const brancher = (s) => {
    s.dataset.vu = '1';
    (s.closest('.card__inner') || s.parentElement).addEventListener('mouseenter', () => preparer(s), { once: true });
    if (io) io.observe(s);
  };
  const tout = () => document.querySelectorAll('.de-survol:not([data-vu])').forEach(brancher);
  tout();
  // grilles chargees apres coup (onglets, « Mehr anzeigen », filtres)
  new MutationObserver(tout).observe(document.body, { childList: true, subtree: true });
})();

